export const RESOLUTION_QUERY_TOLERANCE_DPPX = 0.005;
